var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbouticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.8H13.5V7H16.5M16.5 21H13.5V12.6H16.5M15 0C13.0302 0 11.0796 0.362121 9.25975 1.06569C7.43986 1.76925 5.78628 2.80048 4.3934 4.1005C1.58035 6.72601 0 10.287 0 14C0 17.713 1.58035 21.274 4.3934 23.8995C5.78628 25.1995 7.43986 26.2307 9.25975 26.9343C11.0796 27.6379 13.0302 28 15 28C18.9782 28 22.7936 26.525 25.6066 23.8995C28.4196 21.274 30 17.713 30 14C30 12.1615 29.612 10.341 28.8582 8.64243C28.1044 6.94387 26.9995 5.40053 25.6066 4.1005C24.2137 2.80048 22.5601 1.76925 20.7403 1.06569C18.9204 0.362121 16.9698 0 15 0Z",
    fill: "#B951DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbouticon);
export default __webpack_public_path__ + "static/media/About icon.ca3670ce042b9f92f0d084d1b5bbc838.svg";
export { ForwardRef as ReactComponent };